<template>
  <div class="popup-window-center">
    <div class="popup-body">
      <ThemedEntityForm
        class="activity-popup-card"
        :title="$t('general.member.activityLog')"
        icon="history"
        :focus-first-control="false"
        :close-label="$t('general.notes.close')"
        @cancel="close"
      >
        <div class="content-container-overflow">
          <ActivityTab :member-id="String(memberId)"></ActivityTab>
        </div>
        <template #actions>
          <d-button theme="light" @click="close">{{ $t('general.notes.close') }}</d-button>
        </template>
      </ThemedEntityForm>
    </div>
  </div>
</template>

<script>
import ActivityTab from '@/components/MemberDetailsPopup/ActivityTab';
import ThemedEntityForm from '@/components/ThemedEntityForm';

export default {
  name: 'ActivityPopup',
  components: { ActivityTab, ThemedEntityForm },
  props: {
    memberId: {
      required: true,
      type: [Number, String],
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.content-container-overflow {
  max-height: min(66vh, 640px);
  overflow-y: auto;
}
.activity-popup-card { margin-inline: auto !important; width: min(calc(100vw - 2rem), 48rem) !important; }
</style>
